import React, { createContext, useMemo, useState } from "react";

const ToastContext = createContext();

const ToastProvider = ({ children }) => {
  const [type, setType] = useState("success");
  const [isVisible, setIsVisible] = useState(false);
  const [text, setText] = useState("E-mail saadetud!");

  const value = useMemo(
    () => ({
      type,
      text,
      isVisible,
      setType,
      setText,
      setIsVisible,
    }),
    [type, text, isVisible],
  );

  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
};

export { ToastContext, ToastProvider };
